import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TurnoUACModel } from 'src/app/models/turnoUAC.model';
import { WebsocketService } from '../websocket/websocket.service';
import { AppSettings } from 'src/app/app.settings';
import { UrlService } from 'src/app/shared/services/url.service';

@Injectable()
export class TableroTurnosService {

    public turnos: Subject<TurnoUACModel>;
    public sede: string;
    constructor(private wsService: WebsocketService, private urlService: UrlService) {
    }


    public obtenerTurnosWebSocket() {
        const endpoint = this.urlService.API_WEBSOCKET_TURNOS + "/" + this.sede;
        this.turnos = <Subject<TurnoUACModel>>this.wsService.connect(endpoint).map(
            (response: MessageEvent): TurnoUACModel => {
                return JSON.parse(response.data);
            }
        );
    }

    /**
     * sede setting parameter to request.
     * @param sede 
     */
    public setSedePeticion(sede: string) {
        this.sede = sede;

    }


    destroyWs(): void {
        console.log('Se llamo al metodo onDestroy del ws ' + new Date());
        this.wsService.destroy();

    }
}
